export default "__VITE_ASSET__B4MTo2fT__"